



































































































































 
import { Component, Provide, Vue, Watch ,Prop } from "vue-property-decorator";
import { Provides } from '@/API/Tenant/Weixin';


@Component({
  components: {
  }
})

export default class extends Vue {
  @Prop() private propPageinfo!:any;
  @Provide() timer:any =  "";
  @Provide() headerTime:any = "";
  
  async created(){
    // 计时
    let _this = this;
    _this.timer = setInterval(function(){
       _this.headerTime = //修改数据date
        new Date().getHours() + ":" + (new Date().getMinutes()<10?"0" + new Date().getMinutes():new Date().getMinutes())
    }, 1000);
  }
}
